import { render, staticRenderFns } from "./AoC.vue?vue&type=template&id=871bb906&scoped=true&"
import script from "./AoC.vue?vue&type=script&lang=js&"
export * from "./AoC.vue?vue&type=script&lang=js&"
import style0 from "./AoC.vue?vue&type=style&index=0&id=871bb906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871bb906",
  null
  
)

export default component.exports